export default "__VITE_ASSET__10542146__"